<template>
  <section>
    <div class="page">
      <div>
        <h2>Which country/region is ToTok available in?</h2>
        <p>
          ToTok is available in many countries and regions, including Algeria,
          Bahrain, Bangladesh, Cambodia, Djibouti, Egypt, India, Indonesia,
          Iran, Iraq, Israel, Jordan, Kuwait, Lebanon, Libya, Malaysia, Malta,
          Morocco, Oman, Pakistan, Philippines, Qatar, Saudi Arabia, Singapore,
          Syria, Thailand, Tunisia, United Arab Emirates, Vietnam, Palestine,
          Yemen, and more.
        </p>
        <p>
          Go to app store to search for and download ToTok. Then enjoy free
          calling and messaging with ToTok.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
